// External dependencies
import get from "lodash.get";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// Components
import BatchPrintButton from "../../blocks/Button/BatchPrintButton"
import Loading from "../../../Global/Loading";
import PageStatus from "../../../Teacher/PageStatus";
import Error from "../../../Teacher/Error";
import ProgressReportBatchPrint from "./ProgressReportBatchPrint";
import ProgressReport from '../../blocks/Charts/Progress';
import { states } from "../../values/enums";
import getNonEarlyReaderCount from './functions/getNonEarlyReaderCount';

class ProgressContainer extends Component {
  
  constructor (props) {
    super(props)
    this.state = {
      componentError: null,
    };
  }

  componentDidMount() {
    this.props.initializeData();
  }


  render () {
    const { report: inputReport, reportStatus, batchPrint, selectedLocale } = this.props;
    let isValidActivity = inputReport?.data?.length > 0;
    const report = {
      ...inputReport,
    }
    let notEarlyReaderCount = getNonEarlyReaderCount(report)
    let isOnlyEarlyReader = isValidActivity && notEarlyReaderCount === 0 ? true : false;

    if(this.state.componentError) {
      return <Error customMessage={this.state.componentError} />;
    }

    let progressContents;
    if(reportStatus && reportStatus.type === states.COMPLETE) {
      if(isValidActivity && !(this.props.selectedMetric.value !== "ARM" && isOnlyEarlyReader)) {
        progressContents =
        <React.Fragment>
          <div style={{marginBottom: 16}}>
            <BatchPrintButton />
          </div>
          <ProgressReport
            report={report}
            onClick={this.onChartClick}
            selectedBenchmark={this.props.selectedBenchmark}
            customBenchmarks={this.props.customBenchmarks}
            selectedEquating={this.props.selectedEquating}
            notEarlyReaderCount={notEarlyReaderCount} 
            selectedLocale={this.props.selectedLocale}
            selectedMetric={this.props.selectedMetric}
            selectedStatePercentileCuts={this.props.selectedStatePercentileCuts}
          />
          </React.Fragment>
      } else {
        let equated = false;
        if (
          this.props.selectedMetric &&
          this.props.selectedMetric.value == "ORF" &&
          this.props.selectedEquating
        ) {
          equated = true;
        }
        progressContents = (
          <PageStatus
            isAggregateReport={false}
            equated={equated}
            isOnlyEarlyReader={isOnlyEarlyReader}
            viewText="progress"
          />
        );
      }
    } else if (
      this.props.reportStatus &&
      this.props.reportStatus.type === states.ERROR
    ) {
      progressContents = <Error />;
    } else {
      progressContents = <Loading />;
    }

    return (
      <div className="reports-container progress">
        {batchPrint ? <ProgressReportBatchPrint /> : progressContents}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { roster } = state.reports;
  return {
    roster,
    batchPrint: roster.batchPrint,
    selectedMetric: get(state, "reports.teacher.selections.metric", {}),
    selectedEquating: get(state, "reports.teacher.equatingSelection", true),
    selectedLocale: get(state, 'reports.teacher.selectedLocale', null),
    selectedStatePercentileCuts: get(state, "reports.teacher.selectedStatePercentileCuts", null),
    report: get(state, "reports.progress.report.data", null),
    reportStatus: get(state, "reports.progress.report.status", null),
    selectedBenchmark: get(state, "reports.teacher.selections.benchmark", {}),
    customBenchmarks: get(state, "reports.teacher.customBenchmarks"),
  };
};

// TODO: define propTypes
ProgressContainer.propTypes = {
  report: PropTypes.object,
  status: PropTypes.string,
};

export default connect(mapStateToProps)(ProgressContainer);
